import { __decorate } from "tslib";
import { I18nThemed } from 'interfaces/mixins';
import { v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/mixins/Themed';
import css from '../css/document.m.css';
let FormThanksPage = class FormThanksPage extends I18nThemed {
    render_prologue() {
        const { thanksPrologue } = this.properties;
        if (thanksPrologue.data.length > 0) {
            return v('div', { innerHTML: thanksPrologue.data });
        }
        return null;
    }
    render_epilogue() {
        const { thanksEpilogue } = this.properties;
        if (thanksEpilogue.data.length > 0) {
            return v('div', { innerHTML: thanksEpilogue.data });
        }
        return null;
    }
    render() {
        const { title, description } = this.properties;
        return v('div', { classes: [this.theme(css.root)] }, [
            v('h1', { classes: [this.theme(css.heading)] }, [title]),
            v('article', { classes: [this.theme(css.article)] }, [
                v('p', {}, [description && description.data]),
                this.render_prologue(),
                this.render_epilogue()
            ])
        ]);
    }
};
FormThanksPage = __decorate([
    theme(css)
], FormThanksPage);
export { FormThanksPage };
